(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-cart-drawer"]) return;
  try {
    
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* FC market gate: when this market renders the legacy drawer instead,
     the FC element is absent - do not attach FC behaviour to the legacy drawer. */
  if (!document.querySelector('cart-drawer.fc-cart-drawer')) return;

  /* ============================================================
     Quantity steppers (delegated — survives drawer re-render)
     ============================================================ */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fc-qty-step]');
    if (!btn) return;

    var wrapper = btn.closest('line-item-quantity');
    var input = wrapper && wrapper.querySelector('.quantity-input');
    if (!input) return;

    var step = parseInt(btn.getAttribute('data-fc-qty-step'), 10);
    var current = parseInt(input.value, 10) || 0;
    var max = parseInt(input.getAttribute('max'), 10);
    var next = current + step;

    if (next < 1) next = 1; /* removal is handled by the trash icon */
    if (!isNaN(max) && next > max) next = max;
    if (next === current) return;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Mobile quick-buy drag handle (Figma 603-7836) → close the size sheet. */
  document.addEventListener('click', function (event) {
    var handle = event.target.closest('[data-fc-qb-handle]');
    if (!handle) return;
    var drawer = handle.closest('quick-buy-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });

  /* ============================================================
     "View cart" inside the added-to-cart notification → open the cart drawer
     (and close the notification popover) instead of navigating to /cart.
     show() is idempotent, so if the drawer is already open it simply stays open.
     ============================================================ */
  document.addEventListener('click', function (event) {
    var viewCart = event.target.closest('[data-fc-view-cart]');
    if (!viewCart) return;
    event.preventDefault();

    var popup = viewCart.closest('quick-buy-drawer, cart-notification-drawer');
    if (popup && typeof popup.hide === 'function') popup.hide();

    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    } else {
      window.location.href = viewCart.getAttribute('href') || (ROOT + 'cart');
    }
  });

  /* ============================================================
     Quick-buy size-picker drawers — one per product handle, created lazily in
     <body> and reused. Keeping them in <body> (NOT the re-rendering cart inner)
     means a cart re-render can never orphan/duplicate them, which is what made the
     [aria-controls] delegate double-fire ("VOEG TOE opens twice"). The native
     aria-controls toggle drives open/close once the element exists.
     ============================================================ */
  function ensureQuickBuys() {
    document.querySelectorAll('[data-fc-quickbuy-handle]').forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var handle = btn.getAttribute('data-fc-quickbuy-handle');
      if (!id || !handle || document.getElementById(id)) return;

      var drawer = document.createElement('quick-buy-drawer');
      drawer.id = id;
      drawer.setAttribute('handle', handle);
      drawer.setAttribute('header-bordered', '');
      drawer.setAttribute('open-from', 'bottom');
      drawer.setAttribute('role', 'region');
      drawer.setAttribute('aria-live', 'polite');
      drawer.setAttribute('data-fc-cart-qb', '');
      drawer.className = 'quick-buy-drawer drawer';
      document.body.appendChild(drawer);
    });
  }

  /* Drop the quick-buy drawers we created once their product leaves the recs
     (kept tidy; never touches a drawer that is currently open). */
  function cleanupQuickBuys() {
    document.querySelectorAll('body > quick-buy-drawer[data-fc-cart-qb]').forEach(function (drawer) {
      if (drawer.hasAttribute('open')) return;
      var handle = drawer.getAttribute('handle');
      if (!document.querySelector('[data-fc-quickbuy-handle="' + handle + '"]')) {
        drawer.remove();
      }
    });
  }

  /* ============================================================
     Quick-buy CTA label → single "Voeg toe aan winkelwagen" (Figma). The theme
     rewrites the button text on open + every variant change, so we re-set it after
     (document-level listener runs after the buy-buttons target listener).
     ============================================================ */
  var QB_CTA_LABEL = 'Voeg toe aan winkelwagen';

  function relabelQuickBuyCta(scope) {
    if (!scope) return;
    var btn = scope.querySelector('.quick-buy-drawer__info button[type="submit"]');
    if (!btn) return;
    var target = (btn.getAttribute('is') === 'custom-button' && btn.firstElementChild) ? btn.firstElementChild : btn;
    if (target.textContent.trim() !== QB_CTA_LABEL) target.textContent = QB_CTA_LABEL;
  }

  /* Stock line display — show the .fc-qb-stock span for the chosen variant (fallback to
     the first). Driven here (synced) instead of trusting the theme <variant-inventory>
     toggling or the server's selected-variant comparison, so it shows reliably. */
  function showQuickBuyStock(scope, variantId) {
    if (!scope) return;
    var stock = scope.querySelector('.fc-qb-stock');
    if (!stock) return;
    var items = stock.querySelectorAll('.fc-qb-stock__item');
    if (!items.length) return;
    var matched = false;
    items.forEach(function (item) {
      var match = variantId != null && String(item.getAttribute('data-variant-id')) === String(variantId);
      item.toggleAttribute('hidden', !match);
      if (match) matched = true;
    });
    if (!matched) {
      items.forEach(function (item, i) { item.toggleAttribute('hidden', i !== 0); });
    }
  }

  function selectedVariantId(scope) {
    var input = scope.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  document.addEventListener('dialog:after-show', function (event) {
    if (event.target && event.target.tagName === 'QUICK-BUY-DRAWER') {
      relabelQuickBuyCta(event.target);
      showQuickBuyStock(event.target, selectedVariantId(event.target));
    }
  });

  document.addEventListener('variant:change', function (event) {
    var drawer = event.target && event.target.closest ? event.target.closest('quick-buy-drawer') : null;
    if (!drawer) return;
    var variantId = event.detail && event.detail.variant ? event.detail.variant.id : selectedVariantId(drawer);
    showQuickBuyStock(drawer, variantId);
    setTimeout(function () { relabelQuickBuyCta(drawer); }, 0);
  });

  /* When adding from a quick-buy: skip the theme's "Toegevoegd!" confirmation and open
     the cart drawer instead. Capture phase runs before QuickBuyDrawer._onVariantAdded
     (which shows the confirmation + sets blockCartDrawerOpening); stopPropagation cancels
     both. cart:change (a separate event) still refreshes the drawer contents. */
  document.addEventListener('variant:add', function (event) {
    var qb = event.target && event.target.closest ? event.target.closest('quick-buy-drawer') : null;
    if (!qb) return;
    event.stopPropagation();
    if (typeof qb.hide === 'function') qb.hide();
    var cart = document.getElementById('cart-drawer');
    if (cart && typeof cart.show === 'function') cart.show();
  }, true);

  /* ============================================================
     Product feature — size-picker sheet (multi-variant upsell)
     The sheet is authored inside the re-rendering cart card, so we relocate it to <body>
     (like the quick-buys above) — a cart re-render can then never orphan/clip it — and pin
     it to the drawer's visible bounds so it reads as a bottom sheet on the drawer, immune
     to the drawer's scrolling / transformed ancestors.
     ============================================================ */
  var FEATURE_SHEET_ID = 'fc-cart-feature-sheet';
  var featureOpener = null;   /* the ADD button that opened the sheet (focus is restored to it) */
  var featureRepos = null;    /* resize handler, bound only while open */
  var featurePendingAdd = false; /* true between CTA submit and the add resolving */

  function featureSheetEl() { return document.getElementById(FEATURE_SHEET_ID); }
  function featureOpenBtn() { return document.querySelector('#cart-drawer [data-fc-feature-open]'); }

  /* The drawer closes itself on any click its focus-trap sees as "outside" (theme
     DialogElement._allowOutsideClick → this.hide()). Our sheet lives in <body>, so a size
     click reads as outside and closes the cart. Registering the sheet as an extra trap
     container (focus-trap v7 updateContainerElements) makes in-sheet clicks count as inside,
     so the drawer stays open while the sheet is up; restored to just the drawer on close. */
  function setFeatureTrapContainers(includeSheet) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var trap = drawer.focusTrap; /* public getter; the trap already exists while the drawer is open */
    if (!trap || typeof trap.updateContainerElements !== 'function') return;
    var containers = [drawer, drawer.shadowRoot];
    var sheet = includeSheet ? featureSheetEl() : null;
    if (sheet) containers.push(sheet);
    try { trap.updateContainerElements(containers); } catch (e) {}
  }

  /* Pin the sheet + its scrim to the drawer's on-screen rectangle (full-width mobile,
     ~30rem right-hand panel on desktop). Re-run on open + resize. */
  function positionFeatureSheet(sheet) {
    var drawer = document.getElementById('cart-drawer');
    var panel = sheet.querySelector('.fc-cart-feature-modal__sheet');
    var scrim = sheet.querySelector('.fc-cart-feature-modal__scrim');
    if (!drawer || !panel) return;
    var r = drawer.getBoundingClientRect();
    panel.style.left = r.left + 'px';
    panel.style.right = 'auto';
    panel.style.width = r.width + 'px';
    panel.style.bottom = Math.max(0, window.innerHeight - r.bottom) + 'px';
    if (scrim) {
      scrim.style.top = r.top + 'px';
      scrim.style.left = r.left + 'px';
      scrim.style.width = r.width + 'px';
      scrim.style.height = r.height + 'px';
      scrim.style.right = 'auto';
      scrim.style.bottom = 'auto';
    }
  }

  function openFeatureSheet() {
    var sheet = featureSheetEl();
    if (!sheet || sheet.classList.contains('is-open')) return;
    featureOpener = featureOpenBtn();
    sheet.hidden = false;
    positionFeatureSheet(sheet);
    /* next frame so the un-hidden sheet transitions in from translateY(100%) */
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    if (featureOpener) featureOpener.setAttribute('aria-expanded', 'true');
    setFeatureTrapContainers(true); /* keep the cart open while the sheet is up */
    featureRepos = function () { positionFeatureSheet(sheet); };
    window.addEventListener('resize', featureRepos);
    /* move focus into the sheet (Tab trap + Esc handled by the wired listeners) */
    var first = sheet.querySelector('[data-fc-feature-size]:not([disabled]), [data-fc-feature-cta]');
    if (first) first.focus();
  }

  function closeFeatureSheet() {
    var sheet = featureSheetEl();
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    setFeatureTrapContainers(false); /* hand outside-click dismissal back to the drawer */
    var opener = featureOpenBtn();
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (featureRepos) { window.removeEventListener('resize', featureRepos); featureRepos = null; }
    /* restore focus to the opener, then hide after the slide-out so it isn't tabbable */
    if (featureOpener && document.contains(featureOpener)) featureOpener.focus();
    featureOpener = null;
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 450);
  }

  /* Stock texts are server-rendered per variant in fc-cart-product-feature.liquid
     (app-translated by Translate & Adapt); only toggle visibility — never write text. */
  function setFeatureStock(sheet, variantId, state) {
    var stock = sheet.querySelector('[data-fc-feature-stock]');
    if (!stock) return;
    var texts = Array.prototype.slice.call(sheet.querySelectorAll('[data-fc-feature-stock-text]'));
    var found = false;
    texts.forEach(function (t) {
      var match = t.getAttribute('data-variant-id') === String(variantId);
      t.hidden = !match;
      if (match) found = true;
    });
    if (found && state !== 'out') {
      stock.className = 'fc-cart-feature-modal__stock ' + (state === 'low' ? 'is-low' : 'is-in');
      stock.hidden = false;
    } else {
      stock.hidden = true;
    }
  }

  function wireFeatureSheet(sheet) {
    if (sheet.dataset.fcWired === '1') return;
    sheet.dataset.fcWired = '1';

    var sizes = Array.prototype.slice.call(sheet.querySelectorAll('[data-fc-feature-size]'));
    var idInput = sheet.querySelector('[data-fc-feature-variant-input]');
    var cta = sheet.querySelector('[data-fc-feature-cta]');
    var form = sheet.querySelector('.fc-cart-feature-modal__form');
    var selectedId = null;

    function selectTile(tile) {
      if (!tile || tile.hasAttribute('disabled')) return;
      sizes.forEach(function (s) { s.classList.remove('is-selected'); });
      tile.classList.add('is-selected');
      selectedId = tile.getAttribute('data-variant-id');
      if (idInput) idInput.value = selectedId;
      setFeatureStock(sheet, selectedId, tile.getAttribute('data-state'));
      if (cta) cta.disabled = false;
    }

    sizes.forEach(function (tile) {
      tile.addEventListener('click', function () { selectTile(tile); });
    });

    /* Pre-select the initially-selected (or first available) size, matching the design. */
    var preselected = sheet.querySelector('[data-fc-feature-size].is-selected') ||
      sizes.filter(function (s) { return !s.hasAttribute('disabled'); })[0];
    if (preselected) selectTile(preselected);
    else if (cta) cta.disabled = true;

    /* Never submit without a size (the hidden id would keep its default otherwise). The
       CTA is type=submit → the theme product-form adds the chosen variant + refreshes the
       drawer (cart:change); the variant:add listener below then closes this sheet. */
    if (form) form.addEventListener('submit', function (e) {
      if (!selectedId) { e.preventDefault(); return; }
      featurePendingAdd = true;
    });

    /* Close affordances: mobile drag-handle, desktop back chevron, and the scrim. */
    sheet.querySelectorAll('[data-fc-feature-close]').forEach(function (el) {
      el.addEventListener('click', closeFeatureSheet);
    });

    /* Any click outside the sheet panel (scrim or the dimmed page beside the drawer)
       closes it — closeFeatureSheet is idempotent, so the scrim's own handler is safe. */
    sheet.addEventListener('click', function (e) {
      if (!e.target.closest('.fc-cart-feature-modal__sheet')) closeFeatureSheet();
    });

    /* Esc closes; Tab is trapped inside the sheet while open (modal a11y). */
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeFeatureSheet(); return; }
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.slice
        .call(sheet.querySelectorAll('button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var firstEl = focusable[0], lastEl = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    });

    /* Mobile: drag the sheet down to dismiss (mirrors fc-sticky-atc). */
    var panel = sheet.querySelector('.fc-cart-feature-modal__sheet');
    var mqMobile = window.matchMedia('(max-width: 699px)');
    var startY = 0, dy = 0, dragging = false, armed = false;
    var ARM = 8;
    if (panel) {
      panel.addEventListener('touchstart', function (e) {
        if (!sheet.classList.contains('is-open') || !mqMobile.matches) return;
        startY = e.touches[0].clientY; dy = 0; dragging = true; armed = false;
      }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dy = e.touches[0].clientY - startY;
        if (!armed) { if (dy <= ARM) return; armed = true; panel.style.transition = 'none'; }
        e.preventDefault();
        panel.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: false });
      var endDrag = function () {
        if (!dragging) return;
        dragging = false;
        if (!armed) return;
        armed = false;
        var threshold = Math.min(120, (panel.offsetHeight || 400) * 0.3);
        panel.style.transition = '';
        panel.style.transform = '';
        if (dy > threshold) closeFeatureSheet();
      };
      panel.addEventListener('touchend', endDrag);
      panel.addEventListener('touchcancel', endDrag);
    }
  }

  /* Relocate the authored sheet to <body> once; on later re-renders drop the duplicate the
     render authored (keep the wired, relocated one). Mirrors ensureQuickBuys. */
  function ensureFeatureSheet() {
    var src = document.querySelector('#cart-drawer [data-fc-feature-sheet]');
    if (!src) return;
    if (featureSheetEl()) {
      if (src.parentNode) src.parentNode.removeChild(src);
    } else {
      src.id = FEATURE_SHEET_ID;
      src.hidden = true;
      document.body.appendChild(src);
      wireFeatureSheet(src);
    }
  }

  /* Drop the relocated sheet once its card is gone (product added / feature disabled),
     unless it is currently open. */
  function cleanupFeatureSheet() {
    var sheet = featureSheetEl();
    if (!sheet || sheet.classList.contains('is-open')) return;
    if (!featureOpenBtn()) sheet.remove();
  }

  /* Delegated open — the ADD button lives in the re-rendering card. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fc-feature-open]')) openFeatureSheet();
  });

  /* Add finished → the drawer refreshes and hides the card; close the sheet behind it.
     Flag-driven (not event-target based) since variant:add may fire on the document. */
  document.addEventListener('variant:add', function () {
    if (!featurePendingAdd) return;
    featurePendingAdd = false;
    closeFeatureSheet();
  });
  document.addEventListener('cart:error', function () { featurePendingAdd = false; });

  /* If the cart drawer itself closes (Esc, etc.) while the sheet is up, close the sheet too
     so a body-level orphan can't linger over the page. */
  document.addEventListener('dialog:after-hide', function (e) {
    if (e.target && e.target.id === 'cart-drawer') closeFeatureSheet();
  });

  /* ============================================================
     Free gift engine — auto add/remove by threshold
     ============================================================ */
  var giftBusy = false;

  function readGiftConfig() {
    var el = document.querySelector('[data-fc-cart-gift-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function reconcileGift() {
    if (giftBusy) return;
    var cfg = readGiftConfig();
    if (!cfg || !cfg.enabled || !cfg.variantId) return;

    var cart;
    try { cart = await (await fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })).json(); }
    catch (e) { return; }

    var subtotal = 0;
    var giftLine = null;
    var otherCount = 0;
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._gift) {
        giftLine = item;
      } else {
        subtotal += item.final_line_price;
        otherCount += 1;
      }
    });

    /* The gift only qualifies alongside real items — never on its own (e.g. when
       the threshold is 0). If it ends up the sole line, it gets removed below.
       Display order (gift rendered last) is handled in the Liquid loop, not here,
       since Shopify's AJAX cart offers no reliable way to reorder line items. */
    var qualifies = otherCount > 0 && subtotal >= cfg.threshold;

    try {
      if (qualifies && !giftLine) {
        giftBusy = true;
        await postJSON('cart/add.js', { items: [{ id: cfg.variantId, quantity: 1, properties: { _gift: 'true' } }] });
      } else if (!qualifies && giftLine) {
        giftBusy = true;
        await postJSON('cart/change.js', { id: giftLine.key, quantity: 0 });
      } else if (qualifies && giftLine && giftLine.quantity !== 1) {
        giftBusy = true;
        await postJSON('cart/change.js', { id: giftLine.key, quantity: 1 });
      } else {
        return;
      }
    } catch (e) {
      giftBusy = false;
      return;
    }

    giftBusy = false;
    /* cart:refresh re-renders the drawer + cart count; the engine does NOT
       listen to cart:refresh, so this cannot loop. */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  document.addEventListener('cart:change', function () {
    if (giftBusy) return;
    reconcileGift();
  });

  /* Reconcile once on load (e.g. items restored from a previous session) */
  if (document.readyState !== 'loading') {
    reconcileGift();
  } else {
    document.addEventListener('DOMContentLoaded', reconcileGift);
  }

  /* ============================================================
     Recommendations slider — pagination + auto fetch
     ============================================================ */
  function initSlider(slider) {
    if (!slider || slider.dataset.fcInit === '1') return;
    var track = slider.querySelector('[data-fc-rec-track]');
    if (!track) return;

    var nav = slider.querySelector('[data-fc-rec-nav]');
    var progress = nav && nav.querySelector('.fc-cart-rec-slider__progress');

    function update() {
      if (!nav || !progress) return;
      var cards = track.children;

      var maxScroll = track.scrollWidth - track.clientWidth;
      /* Nothing to scroll (≤1 card, or all cards already fit): hide the bar entirely. */
      if (cards.length <= 1 || maxScroll <= 1) { nav.style.display = 'none'; return; }
      nav.style.display = '';

      /* Scrollbar-proportion thumb: visible fraction of the total scroll content.
         Robust to the track's inline padding / gaps (no card-width estimation). */
      var widthPct = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
      var ratio = track.scrollLeft / maxScroll;

      progress.style.width = widthPct + '%';
      progress.style.left = (ratio * (100 - widthPct)) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* The drawer is hidden (zero width) at page load, so the first update()
       reads no overflow. Re-measure when the track gains width on open. */
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var rect = nav.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        track.scrollTo({ left: ratio * (track.scrollWidth - track.clientWidth), behavior: 'smooth' });
      });
    }

    /* Kill the browser's native image/link drag so our handler owns the gesture
       (prevents the translucent drag-ghost on desktop). */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* drag to scroll */
    var dragging = false, moved = false, startX = 0, scrollStart = 0;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return; /* left button only */
      dragging = true; moved = false; startX = e.pageX; scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      e.preventDefault();
      track.scrollLeft = scrollStart - dx;
    });
    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
    });
    /* Swallow the click that ends a drag so cards/links don't fire mid-swipe */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    slider.dataset.fcInit = '1';
    update();
  }

  async function hydrateAutoSlider(slider) {
    if (!slider.hasAttribute('data-fc-rec-auto') || slider.dataset.fcHydrated === '1') return;
    var productId = slider.getAttribute('data-fc-rec-product');
    var track = slider.querySelector('[data-fc-rec-track]');
    if (!productId || !track) return;

    slider.dataset.fcHydrated = '1';
    var limit = slider.getAttribute('data-fc-rec-limit') || 8;
    var url = ROOT + 'recommendations/products?section_id=fc-cart-recommendations&product_id=' + productId + '&limit=' + limit + '&intent=related';

    try {
      var html = await (await fetch(url)).text();
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var cards = parsed.querySelectorAll('.fc-cart-rec');
      if (cards.length === 0) { slider.hidden = true; return; }
      cards.forEach(function (c) { track.appendChild(c); });
      initSlider(slider);
    } catch (e) {
      slider.hidden = true;
    }
  }

  function initSliders() {
    document.querySelectorAll('.fc-cart-rec-slider').forEach(function (slider) {
      if (slider.hasAttribute('data-fc-rec-auto')) {
        hydrateAutoSlider(slider);
      } else {
        initSlider(slider);
      }
    });
  }

  /* The drawer content is replaced on cart:change (inner innerHTML), cart:refresh
     and bfcache restore (CartDrawer._onPageShow → _onCartRefresh → replaceChildren,
     which dispatches NO event). A MutationObserver on the <cart-drawer> host catches
     every path without racing event timings; initSlider is idempotent via fcInit. */
  /* Animate the rewards bar only when its value actually changed since the last
     render. The free-gift engine fires a second, value-identical re-render
     (cart:change → render, then cart:refresh → render) after a gift add/remove,
     and the gift is excluded from rewards_progress — so without this guard the
     mount animation would replay on that redundant render. */
  var lastRewardsProgress = null;
  function syncRewardsBar() {
    var bar = document.querySelector('#cart-drawer .fc-cart-rewards[data-fc-rewards-progress]');
    if (!bar) return;
    var pct = bar.getAttribute('data-fc-rewards-progress');
    if (pct === lastRewardsProgress) return; /* unchanged → leave it static */
    /* Grow from the previously displayed value, not from 0, so the fill continues
       from its last position. First render (null) falls back to 0 for a grow-in. */
    bar.style.setProperty('--fc-rewards-from', (lastRewardsProgress === null ? 0 : lastRewardsProgress) + '%');
    lastRewardsProgress = pct;
    bar.classList.add('fc-cart-rewards--animate');
  }

  function onCartRender() {
    initSliders();
    ensureQuickBuys();
    cleanupQuickBuys();
    ensureFeatureSheet();
    cleanupFeatureSheet();
    syncRewardsBar();
  }

  function bootCartUI() {
    onCartRender();

    if (!window.MutationObserver) return;
    var host = document.getElementById('cart-drawer') || document.body;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; onCartRender(); });
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    bootCartUI();
  } else {
    document.addEventListener('DOMContentLoaded', bootCartUI);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 300;

    document.querySelectorAll('.fc-faq').forEach((sectionEl) => {
      /* ── Tab switching ── */
      const tablist = sectionEl.querySelector('[role="tablist"]');
      if (tablist) {
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const panels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));

        /* Sliding active-tab pill: a single element that animates to the active tab. */
        const indicator = document.createElement('span');
        indicator.className = 'fc-faq__tab-indicator';
        indicator.setAttribute('aria-hidden', 'true');
        tablist.insertBefore(indicator, tablist.firstChild);

        const moveIndicator = (tab) => {
          if (!tab) return;
          indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
          indicator.style.width = tab.offsetWidth + 'px';
        };
        const activeTab = () =>
          tablist.querySelector('[role="tab"][aria-selected="true"]') || tabs[0];

        /* Position under the current tab, then enable the transition next frame so the
           pill doesn't slide in from the left on first paint. */
        moveIndicator(activeTab());
        requestAnimationFrame(() => tablist.classList.add('fc-faq__tabs--ready'));

        const switchTab = (newTab) => {
          tabs.forEach((tab, i) => {
            const selected = tab === newTab;
            tab.setAttribute('aria-selected', selected);
            tab.setAttribute('tabindex', selected ? '0' : '-1');
            if (panels[i]) {
              panels[i].setAttribute('aria-hidden', !selected);
            }
          });
          moveIndicator(newTab);
          newTab.focus();
        };

        /* Keep the pill aligned when tab widths change (breakpoint/resize). */
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => moveIndicator(activeTab()), 150);
        });

        tablist.addEventListener('click', (e) => {
          const tab = e.target.closest('[role="tab"]');
          if (tab) switchTab(tab);
        });

        tablist.addEventListener('keydown', (e) => {
          const current = tabs.indexOf(document.activeElement);
          if (current === -1) return;

          let next;
          if (e.key === 'ArrowRight') {
            next = (current + 1) % tabs.length;
          } else if (e.key === 'ArrowLeft') {
            next = (current - 1 + tabs.length) % tabs.length;
          } else if (e.key === 'Home') {
            next = 0;
          } else if (e.key === 'End') {
            next = tabs.length - 1;
          }

          if (next !== undefined) {
            e.preventDefault();
            switchTab(tabs[next]);
          }
        });
      }

      /* ── Exclusive accordion ── */
      const panels = sectionEl.querySelectorAll('.fc-faq__panel');
      panels.forEach((panel) => {
        const items = panel.querySelectorAll('.fc-faq__item');
        const animMap = new WeakMap();

        items.forEach((itemEl) => {
          const summaryEl = itemEl.querySelector('.fc-faq__question');
          const wrapEl = itemEl.querySelector('.fc-faq__answer-wrap');
          if (!summaryEl || !wrapEl) return;

          animMap.set(itemEl, false);

          const syncAria = () => {
            summaryEl.setAttribute('aria-expanded', itemEl.open ? 'true' : 'false');
          };

          const openItem = () => {
            itemEl.open = true;
            syncAria();
            const scrollH = wrapEl.scrollHeight;
            wrapEl.style.maxHeight = scrollH + 'px';
            wrapEl.style.opacity = '1';

            setTimeout(() => {
              animMap.set(itemEl, false);
              wrapEl.style.maxHeight = 'none';
            }, DURATION);
          };

          const closeItem = (cb) => {
            wrapEl.style.maxHeight = wrapEl.scrollHeight + 'px';
            wrapEl.offsetHeight; /* force reflow */
            wrapEl.style.maxHeight = '0';
            wrapEl.style.opacity = '0';

            setTimeout(() => {
              itemEl.open = false;
              syncAria();
              animMap.set(itemEl, false);
              if (cb) cb();
            }, DURATION);
          };

          syncAria();

          if (itemEl.open) {
            wrapEl.style.maxHeight = 'none';
            wrapEl.style.opacity = '1';
          }

          summaryEl.addEventListener('click', (e) => {
            e.preventDefault();
            if (animMap.get(itemEl)) return;
            animMap.set(itemEl, true);

            if (itemEl.open) {
              closeItem();
            } else {
              /* Close any other open item in the same panel */
              const openSibling = panel.querySelector('.fc-faq__item[open]');
              if (openSibling && openSibling !== itemEl) {
                const sibWrap = openSibling.querySelector('.fc-faq__answer-wrap');
                const sibSummary = openSibling.querySelector('.fc-faq__question');
                if (sibWrap) {
                  sibWrap.style.maxHeight = sibWrap.scrollHeight + 'px';
                  sibWrap.offsetHeight;
                  sibWrap.style.maxHeight = '0';
                  sibWrap.style.opacity = '0';
                  setTimeout(() => {
                    openSibling.open = false;
                    if (sibSummary) sibSummary.setAttribute('aria-expanded', 'false');
                  }, DURATION);
                }
              }
              openItem();
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-header"]) return;
  try {
    
/* FC mobile drawer: extends the theme's navigation-drawer but resets the FC
   panels on close instead of the legacy ".panel" markup (which would throw). */
customElements.whenDefined('navigation-drawer').then(function () {
  if (window.customElements.get('fc-nav-drawer')) return;

  var NavigationDrawer = window.customElements.get('navigation-drawer');

  window.customElements.define('fc-nav-drawer', class extends NavigationDrawer {
    /* The base Drawer sets inline top/right which would override the CSS that
       keeps the menu below the announcement bar — pin left only, CSS owns top. */
    _setInitialPosition() {
      this.style.left = '0px';
      this.style.right = null;
      this.style.bottom = null;
      this.style.top = null;
    }

    reinitializeDrawer() {
      this.querySelectorAll('[data-fc-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-fc-panel') !== 'root';
      });

      var form = this.querySelector('form');
      var input = form ? form.elements['q'] : null;

      if (input && input.value !== '') {
        input.value = '';
        form.dispatchEvent(new Event('reset'));
      }
    }
  });
});

/* Panel switching: level 1 <-> level 2 with back button.
   Premium slide + staggered reveal — transform/opacity only (compositor-friendly,
   no layout work), Web Animations API (no library), honors prefers-reduced-motion. */
(function () {
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var animating = false;

  function staggerTargets(panel) {
    if (panel.getAttribute('data-fc-panel') === 'root') {
      return panel.querySelectorAll('.fc-mm__link-item');
    }
    return panel.children;
  }

  function switchPanel(drawer, target, isBack) {
    var panels = Array.prototype.slice.call(drawer.querySelectorAll('[data-fc-panel]'));
    var current = panels.find(function (p) { return !p.hidden; });
    var next = panels.find(function (p) { return p.getAttribute('data-fc-panel') === target; });
    if (!next || next === current) return;

    var scroller = drawer.querySelector('.fc-mm__panels');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var swap = function () {
      panels.forEach(function (p) { p.hidden = p !== next; });
      if (scroller) scroller.scrollTop = 0;
    };

    if (reduceMotion || !current || typeof next.animate !== 'function') {
      swap();
      return;
    }

    if (animating) return;
    animating = true;

    var outX = isBack ? 16 : -16;
    var inX = isBack ? -24 : 24;

    var outAnimation = current.animate(
      { transform: ['translateX(0)', 'translateX(' + outX + 'px)'], opacity: [1, 0] },
      { duration: 150, easing: 'ease-in', fill: 'forwards' }
    );

    outAnimation.finished.then(function () {
      swap();
      outAnimation.cancel();

      next.animate(
        { transform: ['translateX(' + inX + 'px)', 'translateX(0)'], opacity: [0, 1] },
        { duration: 250, easing: EASE }
      );

      Array.prototype.slice.call(staggerTargets(next), 0, 8).forEach(function (child, index) {
        child.animate(
          { transform: ['translateY(10px)', 'translateY(0)'], opacity: [0, 1] },
          { duration: 300, delay: 40 * index, easing: EASE, fill: 'backwards' }
        );
      });

      animating = false;
    }).catch(function () {
      swap();
      animating = false;
    });
  }

  document.addEventListener('click', function (event) {
    var drawer = event.target.closest('.fc-mobile-drawer');
    if (!drawer) return;

    var openButton = event.target.closest('[data-fc-open]');
    var backButton = event.target.closest('[data-fc-back]');
    if (!openButton && !backButton) return;

    switchPanel(drawer, openButton ? openButton.getAttribute('data-fc-open') : 'root', !openButton);
  });
})();

/* Close stale menu state when crossing the desktop/mobile boundary
   (e.g. iPad rotation: landscape = desktop nav, portrait = mobile menu) */
(function () {
  var desktopQuery = window.matchMedia('(min-width: 1150px)');

  function onBreakpointChange(event) {
    if (event.matches) {
      /* entering desktop: a mobile drawer left open would keep the body scroll-locked */
      var drawer = document.getElementById('fc-header-sidebar-menu');
      if (drawer && drawer.hasAttribute('open') && typeof drawer.hide === 'function') {
        drawer.hide();
      }
    } else {
      /* entering mobile: an open mega menu would strand the blur backdrop with no way to close */
      document.querySelectorAll('.fc-mega-details[open]').forEach(function (details) {
        details.open = false;
      });
    }
  }

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', onBreakpointChange);
  }
})();

/* Collection cards scroll progress indicator */
document.addEventListener('scroll', function (event) {
  var scroller = event.target;
  if (!(scroller instanceof Element) || !scroller.classList.contains('fc-mm__colls-scroller')) return;

  var track = scroller.parentElement.querySelector('.fc-mm__colls-track');
  var thumb = scroller.parentElement.querySelector('.fc-mm__colls-thumb');
  if (!track || !thumb) return;

  var maxScroll = scroller.scrollWidth - scroller.clientWidth;
  var progress = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
  thumb.style.transform = 'translateX(' + progress * (track.clientWidth - thumb.offsetWidth) + 'px)';
}, { capture: true, passive: true });

  } catch(e) { console.error(e); }
})();
})();
